export const stripeAppearance = {
  variables: {
    fontFamily: 'GT Maru',
    fontSizeBase: '16px',
    fontSizeSm: '14px',
    colorPrimary: '#1B1A1B', // var(--trashie-ui-faded-black-100)
    colorBackground: '#FCFFFD', // var(--trashie-ui-crisp-white)
    colorText: '#1B1A1B', // var(--trashie-ui-faded-black-100)
    colorTextSecondary: '#6F706F', // var(--trashie-ui-faded-black-60)
    colorTextPlaceholder: '#A9A9A9', // var(--trashie-ui-faded-black-40)
    colorDanger: '#FF7F50', // var(--take-back-bags-marmalade-11)
    fontWeightNormal: '400',
    fontWeightMedium: '500',
    fontWeightBold: '700',
    colorSuccess: '#16945F', // var(--trashie-ui-lime)
    iconColor: '#1B1A1B', // var(--trashie-ui-faded-black-100)
    borderRadius: '10px',
  },
  rules: {
    '.Input': {
      border: '1px solid #D9D9D9', // var(--trashie-ui-faded-black-30)
      boxShadow: 'none',
    },
    '.Input:focus': {
      border: '1px solid #6F706F', // var(--trashie-ui-faded-black-60)
      boxShadow: 'none',
    },
    '.Input--invalid': {
      border: '1px solid #FF7F50', // var(--take-back-bags-marmalade-11)
      boxShadow: 'none',
    },
    '.Input--invalid:focus': {
      border: '1px solid #FF7F50', // var(--take-back-bags-marmalade-11)
      boxShadow: 'none',
    },
  },
};

// TODO: Check CDN for fonts
export const stripeFonts = [
  {
    family: 'GT Maru',
    src: 'url(https://storage.googleapis.com/trashie-stripe-assets/GT-Maru-Regular.woff2)',
    weight: '400',
    style: 'normal',
  },
  {
    family: 'GT Maru',
    src: 'url(https://storage.googleapis.com/trashie-stripe-assets/GT-Maru-Medium.woff2)',
    weight: '500',
    style: 'normal',
  },
  {
    family: 'GT Maru',
    src: 'url(https://storage.googleapis.com/trashie-stripe-assets/GT-Maru-Bold.woff2)',
    weight: '700',
    style: 'normal',
  },
  {
    family: 'GT Maru',
    src: 'url(https://storage.googleapis.com/trashie-stripe-assets/GT-Maru-Black.woff2)',
    weight: '900',
    style: 'normal',
  },
];

export const STRIPE_CHECKOUT_SESSION_STATUS = {
  COMPLETE: 'complete',
  EXPIRED: 'expired',
  OPEN: 'open',
};
